import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";



export const CarouselContainer = styled('div', {
  css: [styles.carouselContainer, 'carousel-container'],
  variants: {
    hideOverflow: {
      true: styles.hideOverflow
    },
    ctrlButtons: {
      'around': styles.ctrlButtonsAround,
      'inside': ''
    }
  }
})

export const CarouselCtrls = styled('div', {
  css: [styles.carouselCtrls, 'carousel-ctrl'],
  variants: {
    autoHide : {
      true: [styles.autoHide]
    }
  }
})


